export const Keys = {
  Enter: 13,
  Space: 32,
  Escape: 27,

  ArrowLeft: 37,
  ArrowUp: 38,
  ArrowRight: 39,
  ArrowDown: 40,

  PageUp: 33,
  PageDown: 34,
  End: 35,
  Home: 36,

  One: 49,
  Two: 50,
  Three: 51,
  Four: 52,
  Five: 53,
  Six: 54,
  Seven: 55,
  Eight: 56,
  Nine: 57,
};
